import { isPreview, isProduction } from '@magicschool/utils/nextjs/metadata';

/** CookieYes wires a "reopen consent" click handler to any element carrying this class name. */
export const COOKIEYES_LAUNCHER_CLASS = 'cky-banner-element';

/** True wherever CookieYesClient actually mounts the vendor script for this session. */
export const isCookieYesEnabled = (isStudent: boolean) => !isStudent && (isProduction() || isPreview());
